import React from 'react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { label: 'Tournaments', to: '/tournaments' },
  { label: 'Lessons and Programs', to: '/lessons-and-programs' },
  { label: 'About', to: '/about' },
];

function Navbar() {
  return (
    <header className="navbar-wrap">
      <nav className="navbar surface-card">
        <NavLink to="/tournaments" className="brand-mark">
          <div className="brand-badge">BCI</div>
          <div>
            <div className="brand-title">The Bahamas Chess Institute</div>
            <div className="brand-subtitle">Private lessons, school programs and tournaments</div>
          </div>
        </NavLink>

        <div className="nav-links">
          {tabs.map((tab) => (
            <NavLink
              key={tab.label}
              to={tab.to}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </header>
  );
}

export default Navbar;